import { Outlet } from "react-router-dom";
import "../components/css/icons.css";
import "../components/css/app-style.css";
import "../components/css/sidebar-menu.css";
import DashboardHeader from "./DashboardHeader";
import StudentsSideMenu from "./students/StudentsSideMenu";
import TeacherSideMenu from "./teachers/TeacherSideMenu";
import AdminSideMenu from "./admin/AdminSideMenu";

function DashboardLayout() {
  const userRole = localStorage.getItem('role');
  return (
    <>
      <div id="wrapper">
        {userRole === 'student' && <StudentsSideMenu />}
        {userRole === 'teacher' && <TeacherSideMenu />}
        {userRole === 'admin' && <AdminSideMenu />}
        <DashboardHeader />
        <div className="clearfix"></div>
        <div className="content-wrapper">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
